/* ==========================================================================
   ParfumDistrict — Theme-Verhalten
   Bewusst klein gehalten: keine Abhaengigkeiten, nur das, was der Shop braucht.
   ========================================================================== */

(function () {
  'use strict';

  var PD = window.PD || {};

  /* ----------------------------------------------------------- Helfer -- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return value + ' €';
  }

  /* ------------------------------------------------ Overlay und Drawer -- */

  var overlay = $('[data-pd-overlay]');
  var openDrawer = null;

  function lockScroll(on) {
    document.body.classList.toggle('pd-locked', on);
  }

  function drawerOpen(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose();
    openDrawer = el;
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.removeAttribute('hidden');
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    }
    lockScroll(true);
    var focusable = el.querySelector('[data-pd-drawer-close], button, a[href], input');
    if (focusable) focusable.focus();
  }

  function drawerClose() {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    lockScroll(false);
    openDrawer = null;
    window.setTimeout(function () {
      if (!el.classList.contains('is-open')) {
        el.setAttribute('hidden', '');
        if (overlay && !overlay.classList.contains('is-open')) overlay.setAttribute('hidden', '');
      }
    }, 420);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pd-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen($('#' + opener.getAttribute('data-pd-drawer-open')));
      return;
    }
    if (e.target.closest('[data-pd-drawer-close]') || e.target.hasAttribute('data-pd-overlay')) {
      drawerClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') drawerClose();
  });

  /* ------------------------------------------------------- Warenkorb --- */

  function cartCountUpdate(count) {
    $$('[data-pd-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function cartRefresh() {
    return fetch(PD.routes.cart + '?t=' + Date.now(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountUpdate(cart.item_count);
        cartRender(cart);
        return cart;
      });
  }

  function cartRender(cart) {
    var body = $('[data-pd-cart-body]');
    var foot = $('[data-pd-cart-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="pd-lede" style="text-align:center;padding:48px 0">Dein Warenkorb ist noch leer.</p>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    if (foot) foot.removeAttribute('hidden');

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" width="72" height="90" loading="lazy">'
        : '<span class="pd-placeholder" style="display:block;width:72px;height:90px"></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="pd-card__meta">' + item.variant_title + '</p>' : '';
      return (
        '<div class="pd-cart-line" data-line-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="pd-cart-line__media">' + img + '</a>' +
          '<div class="pd-cart-line__body">' +
            '<a href="' + item.url + '" class="pd-cart-line__title">' + item.product_title + '</a>' +
            variant +
            '<div class="pd-cart-line__foot">' +
              '<div class="pd-qty pd-qty--sm">' +
                '<button type="button" data-pd-line-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Menge verringern">&minus;</button>' +
                '<span style="min-width:34px;text-align:center;font-size:13px">' + item.quantity + '</span>' +
                '<button type="button" data-pd-line-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
              '</div>' +
              '<span class="pd-cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="pd-cart-line__remove" data-pd-line-change="' + item.key + '" data-qty="0">Entfernen</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var total = $('[data-pd-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function lineChange(key, qty) {
    return fetch(PD.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountUpdate(cart.item_count);
        cartRender(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pd-line-change]');
    if (!btn) return;
    e.preventDefault();
    lineChange(btn.getAttribute('data-pd-line-change'), parseInt(btn.getAttribute('data-qty'), 10));
  });

  /* --------------------------------------------- In den Warenkorb (AJAX) */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pd-add-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(PD.routes.cart_add, { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || PD.strings.error);
        return cartRefresh();
      })
      .then(function () {
        drawerOpen($('#pd-cart-drawer'));
      })
      .catch(function (err) {
        var note = form.querySelector('[data-pd-form-error]');
        if (note) { note.textContent = err.message; note.removeAttribute('hidden'); }
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ------------------------------------------------------ Mengenfelder -- */

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-pd-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-pd-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------- Variantenauswahl Produkt -- */

  $$('[data-pd-variants]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-pd-variant-json]').textContent);
    var form = document.getElementById(root.getAttribute('data-pd-form-id'));
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');

    root.addEventListener('change', function () {
      var chosen = $$('select, input:checked', root).map(function (el) { return el.value; });
      var match = data.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      var submit = form.querySelector('[type="submit"]');
      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = 'Nicht verfügbar'; }
        return;
      }
      idInput.value = match.id;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'In den Warenkorb' : PD.strings.soldOut;
      }
      $$('[data-pd-price-target]').forEach(function (el) { el.innerHTML = match.priceHtml; });

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    });
  });

  /* ---------------------------------------------------- Produkt-Tabs ---- */

  /* Seitenweit abgefangen: funktioniert auch, wenn der Theme-Editor einen
     Bereich neu laedt, und unabhaengig davon, wo die Reiter im Markup liegen. */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pd-tab]');
    if (!tab) return;
    var root = tab.closest('[data-pd-tabs]');
    if (!root) return;
    e.preventDefault();
    var id = tab.getAttribute('data-pd-tab');
    $$('[data-pd-tab]', root).forEach(function (t) {
      t.setAttribute('aria-selected', String(t === tab));
    });
    $$('[data-pd-panel]', root).forEach(function (p) {
      var show = p.getAttribute('data-pd-panel') === id;
      p.toggleAttribute('hidden', !show);
      if (show) {
        p.classList.remove('is-entering');
        void p.offsetWidth; /* Animation neu starten */
        p.classList.add('is-entering');
      }
    });
  });

  /* -------------------------------------------------------- Akkordeon --- */

  $$('[data-pd-accordion] details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      $$('[data-pd-accordion] details').forEach(function (o) {
        if (o !== d && o.closest('[data-pd-accordion]') === d.closest('[data-pd-accordion]')) o.open = false;
      });
    });
  });

  /* ---------------------------------------------------- Merkliste ------ */
  /* Nur im Browser gespeichert. Reicht fuer das Herz an Karte und Produkt. */

  var WISH_KEY = 'pd-wish';

  function wishRead() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
  }

  function wishPaint() {
    var list = wishRead();
    $$('[data-pd-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-pd-wish')) !== -1;
      btn.classList.toggle('is-on', on);
      if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', String(on));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pd-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-pd-wish');
    var list = wishRead();
    var at = list.indexOf(handle);
    if (at === -1) { list.push(handle); } else { list.splice(at, 1); }
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) { /* kein Speicher */ }
    wishPaint();
  });

  wishPaint();

  /* ------------------------------------------------- Sticky-Header ------ */

  var header = $('[data-pd-header]');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      last = y;
    }, { passive: true });
  }

  /* ------------------------------------------------- Erstbefuellung ----- */

  if ($('[data-pd-cart-body]')) cartRefresh();
})();
